import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { buildProgramTree } from "../program-tree";

import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import type { ProgramTree } from "../program-tree";

/**
 * The caller's programs as a tree, with the programs above them that they cannot open. The db decides
 * access, so a super admin gets each program of the account.
 */
export const useProgramTree = (): UseSupabaseLoaderState<ProgramTree> & { reload: () => void } =>
  useSupabaseLoader(async ({ supabase }) => {
    const { data, error } = await supabase.from("program_tree").select("*");
    if (error) throw error;
    return buildProgramTree(data);
  }, []);
